import { atom } from 'jotai'

export const isSetupPaymentOpenAtom = atom<boolean>(false)

isSetupPaymentOpenAtom.onMount = (set) => {
    return () => set(false)
}
export const subscribersSortByAtom = atom<string>('')
export const subscribersSortOrderAtom = atom<string>('')